import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Field } from 'formik';

const statusDropdown = ({
  statusList,
  handleChange,
  // handleStatusChange,
  // To confirm if dropdown change will affect any other fields on the same form
  // For Eg: timesheet page team members dropdown change will re-render project list field
}) => {
  // Team members list
  const status = statusList
    .sort((a, b) => (a.statusName > b.statusName ? 1 : -1))
    .map((statuss, index) => (
      <option className="text-capitalize" key={index} value={statuss._id}>
        {statuss.statusName}
      </option>
    ));

  return (
    <Form.Group controlId="status">
      <Form.Label>Status</Form.Label>
      <>
        <Field
          className="form-select text-capitalize"
          as="select"
          name="status"
          onChange={(e) => {
            handleChange(e);
            // setTimeout(() => {
            //   handleStatusChange(e);
            // }, 0);
          }}
        >
          <option value="all">All</option>
          {status}
        </Field>
      </>
    </Form.Group>
  );
};

statusDropdown.propTypes = {
  statusList: PropTypes.array,
  handleChange: PropTypes.func,
  // handlestatusChange: PropTypes.func,
};

export default statusDropdown;
